import React from 'react';

const TerminalLayout = ({ children, config }) => (
  <div className={`${config.layout.maxWidth} mx-auto relative ${config.layout.containerClass || ''}`}>
    <div 
      className={`relative w-full ${config.layout.backgroundSize || 'bg-cover'} bg-center bg-no-repeat`}
      style={{
        backgroundImage: `url(${config.layout.backgroundImage})`,
        aspectRatio: config.layout.aspectRatio,
        minHeight: config.layout.minHeight,
        width: '100%'
      }}
    >
      <div 
        className="absolute"
        style={{
          top: config.screen.top,
          left: config.screen.left,
          right: config.screen.right,
          bottom: config.screen.bottom,
        }}
      >
        <div className="h-full overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default TerminalLayout;